import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions, scrollToItem} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import {ModalService} from '../../services/modal.service';
import { ComponentsService } from '../../services/components-service';
import { filter, take } from 'rxjs/operators';
import { StorageService } from '../../services/storage.service';
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';


declare const $: any;

@Component({
    selector: 'app-question-traffic-cop-2',
    templateUrl: './question-traffic-cop-2.component.html',
    styleUrls: ['./question-traffic-cop-2.component.scss'],
    standalone: false
})
export class QuestionTrafficCop2Component implements OnInit, OnChanges, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<any>();

  items = [];
  uniqueControlName = `checkbox-image-name-${newGuid()}`;
  selectedItem: any;
  initialAnswer = '';
  eviQuote = false;
  parameter: any;
  constructor(
    private questionService: GlobalQuestionService,
    private modalService: ModalService,
    private componentsService: ComponentsService,
    private storageService: StorageService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  ) {
  }

  ngOnInit(): void {
    this.parameter = this.question?.parameter ? JSON.parse(this.question.parameter) : null;
    if (Array.isArray(this.parameter)) {
      this.eviQuote = this.parameter.some((p: any) => p?.parameter === 'showEviPS' && p?.value === '1');
    }
  }

  ngAfterViewInit(): void {
    this.questionService.initPopoverCustomize();
    if (this.storageService.get('eviState', 'flow') === 'quote') {
      this.questionService.spinnerObservable.pipe(
        filter(spinning => !spinning),
        take(1)
      ).subscribe(() => {
        this.showEviWithUpload();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.initialAnswer = this.question?.answer;
      }
      this.setupOptions();
    }
  }

  setupOptions(): void {
    this.items = [];
    if (this.question?.options) {
      this.items = parseOptions(this.question?.options);
      if (this.items?.length) {
        this.items?.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
      }
    }
    console.log(this.items)
  }
  getGroup(x: number): any {
    return this.items.filter(i => i?.group_id == x);
  }
 

  checkSelect(item: any): void {
    //console.log(item,this.question)
    if (this.question) {
      this.question.answer = item.answer;
      this.question.answer_id = item.cent_aq_answer_id;
      this.questionAnswer.emit(this.question);
    }
  } 
  showEviWithUpload(): void {
    // clear the previous chat and upload: Evi starts a fresh session of its own, and creates its
    // quote with this flow's partner and broker details when a schedule is uploaded
    this.componentsService.sendEviCommand('reset', this.questionFlowSessionQuery.getValue()?.session_id);
    // accept Evi's terms - until they are accepted Evi shows neither the upload disclaimer
    // nor the progress messages
    this.componentsService.setTermsAccepted(true);

    this.componentsService.sendEviCommand('expand')

      $('#evi-upload').removeClass('d-none');
      $('#evi-upload-text').removeClass('d-none');
      setTimeout(() => {
        scrollToItem('evi-upload');
      }, 500);
    }
}
